module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"selectMic":"Выберите микрофон"}}')
  delete Component.options._Ctor
}
